(ns frontend.view.grid.fund-commitments-grid.columns
  (:require [frontend.state.current-session :as session]))

;;default set of selected columns
(def ordered-default-columns
  [:fund-commitment/name
   :fund-commitment/fund
   :fund-commitment/cur-remaining-commitment
   :fund-commitment/cur-committed-amount
   :fund-commitment/cur-called-amount
   :fund-commitment/cur-distributed-amount])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:fund-commitment/name
    :fund-commitment/legal-entity})
